<script setup lang="ts">
/** Forum-Tag-Pill wie im Original: rundes Chip, optional Emoji, aktiver Zustand. */
withDefaults(defineProps<{
  label: string
  emoji?: string
  active?: boolean
}>(), {
  emoji: undefined,
  active: false
})
</script>

<template>
  <span class="dc-tag" :class="{ 'is-active': active }">
    <span v-if="emoji" class="dc-tag-emoji" aria-hidden="true">{{ emoji }}</span>
    {{ label }}
  </span>
</template>

<style scoped>
.dc-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-discord);
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--dc-ink);
  background: var(--dc-bg-input);
  border: 1px solid var(--dc-border-card);
  border-radius: var(--radius-pill);
  padding: 4px 12px;
  white-space: nowrap;
  transition:
    color var(--dur-fast) var(--ease-out),
    border-color var(--dur-fast) var(--ease-out);
}

.dc-tag.is-active {
  color: var(--dc-ink-header);
  border-color: var(--dc-blurple);
  background: var(--dc-mention);
}

.dc-tag-emoji {
  font-size: 0.82rem;
  line-height: 1;
}
</style>
